/** PostHog — csak statisztikai hozzájárulás után töltődik (GDPR). Hibák nem borítják az appot. */

import { isAnalyticsSafeMode } from "@/lib/clientRecovery";

const POSTHOG_KEY = "phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs";
const POSTHOG_HOST = "https://us.i.posthog.com";

function installPosthogStub() {
  if (typeof window === "undefined") return null;
  const existing = window.posthog;
  if (existing?.__SV && typeof existing.init === "function") return existing;
  if (existing && (typeof existing !== "object" || Array.isArray(existing))) {
    try {
      delete window.posthog;
    } catch {
      window.posthog = undefined;
    }
  }
  const e = window.posthog && typeof window.posthog === "object" && !Array.isArray(window.posthog)
    ? window.posthog
    : {};
  e._i = e._i || [];
  window.posthog = e;
  e.__SV = 1;
  const methods =
    "init capture register register_once register_for_session unregister unregister_for_session " +
    "get_distinct_id identify reset opt_in_capturing opt_out_capturing has_opted_in_capturing " +
    "has_opted_out_capturing stopSessionRecording".split(" ");
  methods.forEach((m) => {
    if (typeof e[m] !== "function") {
      e[m] = function (...args) {
        e._i.push([m, ...args]);
      };
    }
  });
  return e;
}

function loadPosthogScript() {
  if (typeof window === "undefined") return;
  if (window.posthog?.__autopark_inited) {
    try {
      window.posthog.opt_in_capturing?.();
    } catch {
      /* ignore */
    }
    return;
  }
  const ph = installPosthogStub();
  if (!ph) return;

  const existing = document.querySelector('script[data-autopark-posthog="1"]');
  if (existing) return;

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.crossOrigin = "anonymous";
  script.async = true;
  script.dataset.autoparkPosthog = "1";
  script.src = `${POSTHOG_HOST.replace(".i.posthog.com", "-assets.i.posthog.com")}/static/array.js`;
  script.onload = () => {
    try {
      const live = window.posthog;
      if (!live || typeof live.init !== "function") return;
      live.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
        person_profiles: "identified_only",
        disable_session_recording: true,
        autocapture: true,
        capture_pageview: true,
      });
      live.__autopark_inited = true;
      live.opt_in_capturing?.();
    } catch (err) {
      if (typeof console !== "undefined") {
        console.warn("[AutoPark] PostHog init skipped:", err);
      }
    }
  };
  script.onerror = () => {
    if (typeof console !== "undefined") {
      console.warn("[AutoPark] PostHog script failed to load");
    }
  };
  document.head.appendChild(script);
}

export function enablePosthogAnalytics() {
  if (typeof window === "undefined") return;
  if (isAnalyticsSafeMode()) return;
  try {
    const schedule =
      typeof requestIdleCallback === "function"
        ? (fn) => requestIdleCallback(fn, { timeout: 4000 })
        : (fn) => window.setTimeout(fn, 50);
    schedule(() => {
      try {
        loadPosthogScript();
      } catch (err) {
        console.warn("[AutoPark] PostHog enable failed:", err);
      }
    });
  } catch {
    /* ignore */
  }
}

export function disablePosthogAnalytics() {
  if (typeof window === "undefined" || !window.posthog) return;
  try {
    window.posthog.opt_out_capturing?.();
    window.posthog.stopSessionRecording?.();
  } catch {
    /* ignore */
  }
}
